// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__iiBLz","icon":"SortAdornment_icon__1KQdt","up":"SortAdornment_up__3Awli","down":"SortAdornment_down__3CbaP","active":"SortAdornment_active__JYtaC"};